export const Config = {
  EMAIL_URL: "https://q7itwuhata.execute-api.us-east-1.amazonaws.com/prod",
  EMAIL_API_KEY: "SQ3psmHXhk7mDkHgeOfGQnCnqd2oRuhaf24WsLwh"
}